export default "__VITE_PUBLIC_ASSET__c3bc34cd__"